import {
  BottomSheet,
  BottomSheetLoadingContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { getSafeAreaPaddings } from "@src/appV2/redesign/system/ui-theme";

interface CheckrLoadingBottomSheetProps {
  modalState: UseModalState;
}

export function CheckrLoadingBottomSheet(props: CheckrLoadingBottomSheetProps) {
  const { modalState } = props;

  return (
    <BottomSheet
      canDismiss={false}
      modalState={modalState}
      paperSx={{
        ...getSafeAreaPaddings({ bottom: true }),
      }}
    >
      <BottomSheetLoadingContent
        title="Redirecting you to Checkr"
        description="Should only take a few seconds"
      />
    </BottomSheet>
  );
}
